export enum PagesList {
  HOME,
  SERVICES,
  ADDITIONAL_INFO,
  GALLERY,
  GET_IN_TOUCH,
  PAGE_NOT_FOUND,
}
